import { CurrentCredentials } from "./currentCredentials";

export class ServerConnection{
   public static callServerWithUsernameAndPassword(service: string, body: Object,username:string,password:string,macAddresses:string[]=[]): Promise<any> {
        (<any>body).AuthenticationInformation= { Username: username, Password: password,MacAddresses:macAddresses };
        return new Promise<JSON>((resolvedFunction, rejectFunction) => {
            let request = new XMLHttpRequest();
            request.open('POST','http://192.168.20.49:48010/api');
            // request.open('POST','http://apadana.dinomotor.com/api');
            // request.open('POST','/api');
            
            let requestBody = `${service}\r\n${JSON.stringify(body)}`;
            request.onload = function () {
                if (this.status == 200) {
                    let result = JSON.parse(request.response);
                    if(result.HasCatastrophicError==false){
                        resolvedFunction(JSON.parse(request.response));
                    }else{
                        rejectFunction({ status: request.status, statusText: result.Faults[0] });
                    }
                } else {
                    rejectFunction({ status: request.status, statusText: request.statusText });
                }
            }
            request.onerror = function () { rejectFunction({ status: request.status, statusText: request.statusText }); }
            request.send(requestBody);
        })
    }

    public static callServer(service: string, body: Object): Promise<any> {
        return this.callServerWithUsernameAndPassword(service,body,CurrentCredentials.username,CurrentCredentials.password,[]);
    }
}